import React from "react";
import {
	MdOutlineSpaceDashboard,
	MdOutlineMonetizationOn,
	MdPeopleOutline,
	MdOutlineSnippetFolder,
	MdOutlineShoppingCart,
	MdOutlineAssignment,
	MdOutlineReceiptLong,
} from "react-icons/md";

const managerMenuItems: any[] = [
	{
		icon: React.createElement(MdOutlineSpaceDashboard, {}),
		name: "Dashboard",
		permission: "Dashboard",
		route: "/manager/admin/dashboard",
		level: 1,
		children: [],
	},
	{
		icon: React.createElement(MdOutlineSpaceDashboard, {}),
		name: "Dashboard",
		permission: "PartnerDashboard",
		route: "/manager/partner/dashboard",
		level: 1,
		children: [],
	},
	{
		icon: React.createElement(MdOutlineMonetizationOn, {}),
		name: "Faturamento",
		permission: "Faturamento",
		route: "",
		level: 1,
		children: [
			{
				icon: "",
				name: "Visão Geral",
				permission: "FaturamentoParceiro",
				route: "/manager/partner/billing",
				level: 2,
				children: [],
			},
			{
				icon: "",
				name: "Retiradas",
				permission: "FaturamentoParceiro",
				route: "/manager/partner/withdrawal",
				level: 2,
				children: [],
			},
			{
				icon: "",
				name: "Extratos",
				permission: "FaturamentoParceiro",
				route: "/manager/partner/statements",
				level: 2,
				children: [],
			},
			{
				icon: "",
				name: "Visão Geral",
				permission: "FaturamentoAdmin",
				route: "/manager/admin/billing",
				level: 2,
				children: [],
			},
			{
				icon: "",
				name: "Solicitações",
				permission: "FaturamentoAdmin",
				route: "/manager/admin/requests",
				level: 2,
				children: [],
			},
		],
	},
	{
		icon: React.createElement(MdPeopleOutline, {}),
		name: "Usuários",
		permission: "Usuarios",
		route: "",
		level: 1,
		children: [
			{
				icon: "",
				name: "Todos os usuários",
				permission: "Usuarios",
				route: "/manager/users",
				level: 2,
				children: [],
			},
			{
				icon: "",
				name: "Adicionar usuários",
				permission: "Usuarios",
				route: "/manager/add-user",
				level: 2,
				children: [],
			},
		],
	},
	{
		icon: React.createElement(MdOutlineSnippetFolder, {}),
		name: "Materiais",
		permission: "Materiais",
		route: "",
		level: 1,
		children: [
			{
				icon: "",
				name: "Materiais Locação",
				permission: "Materiais",
				route: "/manager/materials",
				level: 2,
				children: [],
			},
			{
				icon: "",
				name: "Gerenciar Materiais",
				permission: "Materiais",
				route: "/manager/materials-manager",
				level: 2,
				children: [],
			},
			{
				icon: "",
				name: "Meus Cursos",
				permission: "Cursos",
				route: "/manager/my-courses",
				level: 2,
				children: [],
			},
		],
	},
	{
		icon: React.createElement(MdOutlineReceiptLong, {}),
		name: "Assinaturas",
		permission: "Assinaturas",
		route: "",
		level: 1,
		children: [
			{
				icon: "",
				name: "Todas as assinaturas",
				permission: "Assinaturas",
				route: "/manager/subscriptions",
				level: 2,
				children: [],
			},
			{
				icon: "",
				name: "Adicionar assinatura",
				permission: "Assinaturas",
				route: "/manager/subscriptions/new",
				level: 2,
				children: [],
			},
		],
	},
	{
		icon: React.createElement(MdOutlineShoppingCart, {}),
		name: "Pedidos",
		permission: "Pedidos",
		route: "/manager/orders",
		level: 1,
		children: [],
	},
	{
		icon: React.createElement(MdOutlineAssignment, {}),
		className: "mt-auto",
		name: "Relatórios",
		permission: "Relatorios",
		route: "/manager/reports",
		level: 1,
		children: [],
	},
];

export default managerMenuItems;
